var CryptoJS = require("crypto-js");
export const encryptText = (inputText, key) => {
    return CryptoJS.AES.encrypt(inputText, key).toString();
};
export const decryptText = (encryptedText, key) => {
    let bytes = CryptoJS.AES.decrypt(encryptedText, key);
    return bytes.toString(CryptoJS.enc.Utf8);
};
